import { render, staticRenderFns } from "./DynamicGalleryList.vue?vue&type=template&id=01893c70&scoped=true"
import script from "./DynamicGalleryList.vue?vue&type=script&lang=js"
export * from "./DynamicGalleryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01893c70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01893c70')) {
      api.createRecord('01893c70', component.options)
    } else {
      api.reload('01893c70', component.options)
    }
    module.hot.accept("./DynamicGalleryList.vue?vue&type=template&id=01893c70&scoped=true", function () {
      api.rerender('01893c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/circle/dynamic/DynamicGalleryList.vue"
export default component.exports